module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Foreword"
    }
  }, [_vm._v("Foreword, by Bernadette Peck")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Authors_Note"
    }
  }, [_vm._v("Author’s Note on the Paranormal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1"
    }
  }, [_vm._v("The Ghost Seekers of Central New York")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Central New York")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Haunted Locations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gerber’s 1933 Tavern | "), _c('i', [_vm._v("Utica")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1839 Stone House | "), _c('i', [_vm._v("Prospect")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Liberty Hall | "), _c('i', [_vm._v("Westernville")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Angry Garlic | "), _c('i', [_vm._v("Baldwinsville")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rutger Mansion No. 3 | "), _c('i', [_vm._v("Utica")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brae Loch Inn | "), _c('i', [_vm._v("Cazenovia")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Our Cause Tavern | "), _c('i', [_vm._v("Verona Beach")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Anchor Light Inn | "), _c('i', [_vm._v("Verona Beach")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oneida Lake House | "), _c('i', [_vm._v("Sylvan Beach")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Stief | "), _c('i', [_vm._v("Utica")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stanley Theatre | "), _c('i', [_vm._v("Utica")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sarah E. Gilbert Boarding House | "), _c('i', [_vm._v("Utica")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Masonic Temple | "), _c('i', [_vm._v("Utica")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fort Schuyler Club | "), _c('i', [_vm._v("Utica")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alexander Hamilton Institute | "), _c('i', [_vm._v("Clinton")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Capitol Theatre | "), _c('i', [_vm._v("Rome")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shoppes at the Finish Line | "), _c('i', [_vm._v("Utica")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ilion Little Theatre | "), _c('i', [_vm._v("Ilion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ilion Free Public Library | "), _c('i', [_vm._v("Ilion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Overlook Mansion | "), _c('i', [_vm._v("Little Falls")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whitestown Town Hall | "), _c('i', [_vm._v("Whitesboro")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Utica Public Library | "), _c('i', [_vm._v("Utica")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Colonel Kast House | "), _c('i', [_vm._v("Mudville")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Episcopal Church | "), _c('i', [_vm._v("Herkimer")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1884 Suiter Mansion | "), _c('i', [_vm._v("Herkimer")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Just an Ol’ Farm House | "), _c('i', [_vm._v("West Winfield")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1852 Walcott Family Crypt | "), _c('i', [_vm._v("New York Mills")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Orchard Hall | "), _c('i', [_vm._v("Sauquoit")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gardner Farm Inn | "), _c('i', [_vm._v("Troy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Best of the Rest")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("History of Ghost Hunting")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbd272c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 69
// module chunks = 0